<!-- <button class="btn btn-brand mr-2" (click)="addQuotation()" [translate]="'BUTTONS.ADD_NEW_QUOTATION'">
    <i class="fas fa-plus"></i> Add New Quotation
</button>
<button class="btn btn-info" (click)="viewClientInfo()" [translate]="'BUTTONS.VIEW_CLIENT_INFO'">
    <i class="fas fa-user-tie"></i> View Client Info
</button> -->
<div class="quotation-block" *ngIf="qRecord">
  <table
    class="table table-hover"
    *ngIf="settingsSvc.masterfile$ | async as settings"
  >
    <thead>
      <tr>
        <th width="30">&nbsp;</th>
        <th width="102">&nbsp;</th>
        <th class="text-center" [translate]="'TITLES.COUNTRY'">COUNTRY</th>
        <th [translate]="'TITLES.TIERED_PRICING'">TIERED PRICING</th>
        <th [translate]="'TITLES.LEAD_TIME'" class="text-center" width="120"
          >LEAD TIME</th
        >
        <th [translate]="'TITLES.SAMPLE_DETAILS'" class="text-center" width="120"
          >SAMPLE DETAIL</th
        >
        <th [translate]="'TITLES.QUOTATION_NOTES'">NOTES</th>
        <th [translate]="'TITLES.FILES'">FILES</th>
        <th
          class="text-center"
          width="20"
          *ngIf="authService.loginUser.role != 2 && authService.loginUser.prwx == 7"
        >
          <a
            href="javascript:;"
            mat-mini-fab
            (click)="addQuotation()"
            title="Add new master quote"
          >
            <i class="fas fa-plus"></i>
          </a>
          <!-- <button class="btn btn-brand btn-sm" (click)="addQuotation()"
                        [translate]="'BUTTONS.ADD_NEW_QUOTATION'">
                        <i class="fas fa-plus"></i> Add New Quotation
                    </button> -->
        </th>
        <th class="text-center" *ngIf="authService.loginUser.role == 2">&nbsp;</th>
        <!-- <th [translate]="'TITLES.STATUS'" width="150" class="text-center">STATUS</th>
                <th width="80">&nbsp;</th> -->
      </tr>
    </thead>
    <tbody *ngIf="settings && settings.LOGISTICS">
      <tr *ngIf="quotesService.gettingRecords">
        <td colspan="9" class="text-center">
          <br />
          <h6 [translate]="'GENERAL.GETTING_RECORDS'">
            <i class="fas fa-spinner fa-spin"></i> Getting records...
          </h6>
          <br />
        </td>
      </tr>
      <tr *ngFor="let r of qRecord.data; let i = index">
        <td align="center" valign="middle" width="30">
          <h1>{{ i + 1 }}</h1>
        </td>
        <td align="center" width="150">
          <img
            [src]="url + '/file?f=' + (r.photo != '' ? r.photo : noImgUrl)"
            width="100"
            alt=""
          />
        </td>
        <td class="text-center">
          <h5 class="text-center text-capitalize" *ngIf="r.factory">
            {{ r.factory.factory_name }}
            <ng-container *ngIf="countries[r?.factory?.country]">
              [{{ countries[r?.factory?.country] }}]
            </ng-container>
          </h5>
          <h6 class="text-center">
            <span
              class="text-success"
              [translate]="'LABELS.EXPIRED'"
              *ngIf="!isExpired(r.expiry_dt)"
            >
              {{ 'QUOTE_STATUS.EXPIRES_ON' | translate }}
            </span>
            <span
              class="text-warning"
              *ngIf="isExpired(r.expiry_dt)"
              [translate]="'LABELS.EXPIRED'"
              >Expired</span
            >
            <br />
            <strong class="text-default">
              {{ r.expiry_dt | date: 'longDate' }}
            </strong>
          </h6>

          <br />
          <span
            *ngIf="r.status == 1"
            class="kt-badge kt-badge--warning kt-badge--inline kt-badge--sm m-1"
            [translate]="'QUOTE_STATUS.DRAFT'"
          >
            DRAFT</span
          >
          <span
            *ngIf="r.status == 2"
            class="kt-badge kt-badge--success kt-badge--inline kt-badge--sm m-1"
            [translate]="'QUOTE_STATUS.POSTED'"
          >
            <i class="fas fa-check m-1"></i> POSTED</span
          >
          <span
            *ngIf="r.status == 4"
            class="kt-badge kt-badge--success kt-badge--inline kt-badge--sm m-1"
            [translate]="'QUOTE_STATUS.NEGOTIATED_PRICE'"
          >
            <i class="fas fa-check m-1"></i> POSTED</span
          >
          <span
            *ngIf="r.status == 8"
            class="kt-badge kt-badge--success kt-badge--inline kt-badge--sm m-1"
            [translate]="'QUOTE_STATUS.SAMPLE_ORDERED'"
          >
            <i class="fas fa-check m-1"></i> POSTED</span
          >
          <span
            *ngIf="r.status == 16"
            class="kt-badge kt-badge--success kt-badge--inline kt-badge--sm m-1"
            [translate]="'QUOTE_STATUS.ORDER_PLACED'"
          >
            <i class="fas fa-check m-1"></i> POSTED</span
          >

          <span
            class="kt-badge link kt-badge--info kt-badge--inline kt-badge--sm m-1"
            *ngIf="r.negotiation_count > 0"
            (click)="negotiatePrice(r)"
          >
            <i class="fas fa-dollar-sign mr-1"></i> Price Negotiation
          </span>

          <span
            class="kt-badge kt-badge--warning kt-badge--inline kt-badge--sm m-1"
            *ngIf="r.requote_request_count > 0"
          >
            <i class="fas fa-check-double m-1"></i> Requote Request
          </span>
        </td>
        <td>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th [translate]="'GENERAL.QUANTITY'">QUANTITY</th>
                <th *ngIf="r.logistic_1">
                  {{ settings.LOGISTICS[r.logistic_1] | translate }}
                </th>
                <th *ngIf="r.logistic_2">
                  {{ settings.LOGISTICS[r.logistic_2] | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tp of r.tiered_pricing_json; let i = index">
                <td>{{ tp?.quantity ? tp.quantity : 0 }}</td>
                <td *ngIf="r.logistic_1">
                  <span
                    class="text-warning"
                    *ngIf="
                      authService.loginUser.role != 2 &&
                      authService.loginUser.prwx == 7 &&
                      r.prevQ &&
                      r.prevQ.tiered_pricing_json[i] &&
                      r.prevQ.tiered_pricing_json[i].logistic_1 != tp.logistic_1
                    "
                  >
                    <del>{{
                      r.prevQ.tiered_pricing_json[i].logistic_1
                        | currency: '' : 'symbol' : '1.2-4'
                    }}</del>
                  </span>
                  {{
                    tp?.logistic_1
                      ? tp.logistic_1
                      : (0 | currency: '' : 'symbol' : '1.2-4')
                  }}
                  <!-- <span class="text-success font-500">
                                        [{{ (tp.logistic_1 + (tp.logistic_1 * tp.logistic_1_markup_percent / 100)) | currency: "":"symbol":'1.2-4' }}]
                                    </span> -->
                </td>
                <td *ngIf="r.logistic_2">
                  <span
                    class="text-warning"
                    *ngIf="
                      authService.loginUser.role != 2 &&
                      authService.loginUser.prwx == 7 &&
                      r.prevQ &&
                      r.prevQ.tiered_pricing_json[i] &&
                      r.prevQ.tiered_pricing_json[i].logistic_2 != tp.logistic_2
                    "
                  >
                    <del>{{
                      r.prevQ.tiered_pricing_json[i].logistic_2
                        | currency: '' : 'symbol' : '1.2-4'
                    }}</del>
                  </span>
                  {{
                    tp?.logistic_2
                      ? tp.logistic_2
                      : (0 | currency: '' : 'symbol' : '1.2-4')
                  }}
                  <!-- <span class="text-success font-500">
                                        [{{ (tp.logistic_2 + (tp.logistic_2 * tp.logistic_2_markup_percent / 100)) | currency: "":"symbol":'1.2-4' }}]
                                    </span> -->
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td align="center">
          <div class="lead-time" *ngIf="r.logistic_1">
            <div class="days"
              >{{ settingsSvc.getLeadTime(r.logistic_1, r.lead_time_days_log1) }}
              {{ 'GENERAL.DAYS' | translate }}</div
            >
            <div class="desc">{{
              settings.LOGISTICS[r.logistic_1] | translate
            }}</div>
          </div>
          <br />
          <div class="lead-time" *ngIf="r.logistic_2">
            <div class="days"
              >{{ settingsSvc.getLeadTime(r.logistic_2, r.lead_time_days_log1) }}
              {{ 'GENERAL.DAYS' | translate }}</div
            >
            <div class="desc">{{
              settings.LOGISTICS[r.logistic_2] | translate
            }}</div>
          </div>
        </td>
        <td align="center">
          <div class="lead-time">
            <div class="days">{{
              r.sample_price | currency: '' : 'symbol' : '1.2-4'
            }}</div>
            <div class="desc">{{ 'GENERAL.PRICE' | translate }}</div>
          </div>
          <br />
          <div class="lead-time">
            <div class="days">{{ r.sample_lead_time_days }} days</div>
            <div class="desc">{{ 'TITLES.LEAD_TIME' | translate }}</div>
          </div>
        </td>
        <td>{{ r.notes }}</td>
        <td>
          <cnc-attachments-view
            [attachments]="r.quotation_attachments"
          ></cnc-attachments-view>
        </td>
        <td
          class="text-right"
          *ngIf="authService.loginUser.role != 2 && authService.loginUser.prwx == 7"
        >
          <div
            ngbDropdown
            class="d-inline-block"
            container="'body'"
            placement="bottom-right"
          >
            <a
              href="javascript:;"
              mat-mini-fab
              color="default"
              ngbDropdownToggle
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-v"></i>
            </a>
            <div ngbDropdownMenu aria-labelledby="action-button">
              <button
                ngbDropdownItem
                (click)="createPurchaseOrder(r)"
                *ngIf="authService.loginUser.role >= 88 && !isExpired(r.expiry_dt)"
                class="text-primary"
              >
                <i class="fas fa-file-invoice-dollar text-primary"></i>
                Create Purchase Order
              </button>

              <button
                type="button"
                ngbDropdownItem
                class="text-success"
                title="{{ 'TEXT.EDIT_RECORD' | translate }}"
                (click)="showQuotationForm(r)"
              >
                <i class="fas fa-edit text-success"></i> Edit Quote
              </button>
              <button
                type="button"
                ngbDropdownItem
                class="text-primary"
                title="{{ 'BUTTONS.NEW_VARIANT_QUOTATION' | translate }}"
                (click)="newVariantQuote(r)"
                *ngIf="rfq.product_has_variants == 1"
              >
                <i class="fas fa-plus text-primary"></i> New Variant Quote
              </button>
              <button
                type="button"
                ngbDropdownItem
                *ngIf="r.variant_quotations_count > 0"
                (click)="viewVariantQuotes(r)"
                class="text-info"
              >
                <span class="kt-badge kt-badge--outline kt-badge--brand mr-1">
                  <strong> {{ r.variant_quotations_count }} </strong></span
                >
                View Variant Quotes
              </button>

              <button
                *ngIf="r.negotiation_count > 0"
                class="text-info"
                ngbDropdownItem
                type="button"
                (click)="negotiatePrice(r)"
              >
                <i class="fas fa-dollar-sign text-info"></i> View Price Negotiation
              </button>

              <button
                type="button"
                ngbDropdownItem
                title="{{ 'TEXT.DELETE_RECORD' | translate }}"
                (click)="delete(r)"
                class="text-danger"
              >
                <i class="fas fa-trash text-danger"></i> Delete Quote
              </button>
            </div>
          </div>

          <div class="rfq-q-toolbar" *ngIf="false">
            <div
              class="btn-group btn-sm mb-2"
              role="group"
              aria-label="Rfq Quotation Actions"
            >
              <!-- <button type="button" class="btn btn-default btn-sm" (click)="openMessages(r);">
                                <i class="fas fa-fw fa-comments text-info"></i>
                            </button> -->
              <button
                type="button"
                class="btn btn-default btn-sm"
                title="{{ 'TEXT.EDIT_RECORD' | translate }}"
                (click)="showQuotationForm(r)"
              >
                <i class="fas fa-fw fa-edit text-success"></i>
              </button>
              <button
                type="button"
                class="btn btn-default btn-sm"
                title="{{ 'BUTTONS.NEW_VARIANT_QUOTATION' | translate }}"
                (click)="newVariantQuote(r)"
                *ngIf="rfq.product_has_variants == 1"
              >
                <i class="fas fa-fw fa-plus text-primary"></i>
              </button>
              <button
                type="button"
                class="btn btn-default btn-sm"
                *ngIf="r.variant_quotations_count > 0"
                (click)="viewVariantQuotes(r)"
              >
                <span class="kt-badge kt-badge--outline kt-badge--brand">
                  <strong> {{ r.variant_quotations_count }} </strong></span
                >
              </button>
              <button
                type="button"
                class="btn btn-default btn-sm"
                title="{{ 'TEXT.DELETE_RECORD' | translate }}"
                (click)="delete(r)"
              >
                <i class="fas fa-fw fa-trash text-danger"></i>
              </button>
            </div>

            <button
              *ngIf="r.negotiation_count > 0"
              class="btn btn-outline-info btn-sm"
              type="button"
              (click)="negotiatePrice(r)"
            >
              {{ 'QUOTE_STATUS.PRICE_REQUEST' | translate }}
            </button>

            <button
              *ngIf="r.requote_request_count > 0"
              class="btn btn-outline-warning btn-sm"
              type="button"
              (click)="negotiatePrice(r)"
            >
              Requote Request
            </button>
          </div>
        </td>
        <td class="text-right" *ngIf="authService.loginUser.role == 2">
          <div ngbDropdown class="d-inline-block">
            <a
              href="javascript:;"
              mat-mini-fab
              color="default"
              ngbDropdownToggle
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-v"></i>
            </a>
            <div ngbDropdownMenu aria-labelledby="action-button">
              <button
                type="button"
                ngbDropdownItem
                *ngIf="r.variant_quotations_count > 0"
                (click)="viewVariantQuotes(r)"
                class="text-info"
              >
                <span class="kt-badge kt-badge--outline kt-badge--brand mr-1">
                  <strong> {{ r.variant_quotations_count }} </strong></span
                >
                View Variant Quotes
              </button>

              <button
                *ngIf="r.negotiation_count > 0"
                class="text-info"
                ngbDropdownItem
                type="button"
                (click)="negotiatePrice(r)"
              >
                <i class="fas fa-dollar-sign text-info"></i> View Price Negotiation
              </button>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <mat-paginator
    [length]="qRecord.total"
    [pageSize]="qRecord.per_page"
    [pageSizeOptions]="pageSizeOptions"
    (page)="getRecords($event)"
  >
  </mat-paginator>
</div>
